var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrudVsemIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2529 4.20439C13.5399 4.40323 13.5399 4.82754 13.2529 5.02638L8.86168 8.06873C8.53008 8.29848 8.07693 8.06115 8.07693 7.65774L8.07693 1.57303C8.07693 1.16962 8.53008 0.932293 8.86168 1.16203L13.2529 4.20439Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2529 14.9737C13.5399 15.1725 13.5399 15.5968 13.2529 15.7957L8.86168 18.838C8.53008 19.0678 8.07693 18.8304 8.07693 18.427L8.07693 12.3423C8.07693 11.9389 8.53008 11.7016 8.86168 11.9313L13.2529 14.9737Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29439 9.5494C8.67202 9.73109 8.67202 10.2688 8.29439 10.4505L3.02457 12.986C2.69261 13.1457 2.30779 12.9038 2.30779 12.5354L2.30779 7.46452C2.30779 7.09615 2.69261 6.85424 3.02457 7.01396L8.29439 9.5494Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0635 9.5494C19.4412 9.73109 19.4412 10.2688 19.0635 10.4505L13.7937 12.986C13.4617 13.1457 13.0769 12.9038 13.0769 12.5354L13.0769 7.46452C13.0769 7.09615 13.4617 6.85424 13.7937 7.01396L19.0635 9.5494Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrudVsemIcon);
export default __webpack_public_path__ + "static/media/trud_vsem-icon.37dda60220d31488f3986bde72993f5b.svg";
export { ForwardRef as ReactComponent };